import { toast } from 'react-toastify';
import axios from '../../axios';

import {
  ADD_CITY,
  GET_CITIES,
  GET_CITY,
  UPDATE_CITY,
  DELETE_CITY,
  UPDATE_COUNTRY,
} from '../types';
import { setAlert } from './alert';

// Add City
export const addCity = (formData) => async (dispatch) => {
  try {
    const res = await axios.post(
      `${process.env.REACT_APP_ADMIN_URL}/city/add`,
      formData,
    );
    if (res.data.code === 1) {
      dispatch({ type: ADD_CITY, payload: res.data.data });
      setTimeout(() => {
        toast.success('City added successfully!');
      }, 1000);
    }
    if (res.data.code === 2) {
      setTimeout(() => {
        toast.warn(res.data.message);
      }, 1000);
    }
  } catch (err) {
    if(err.response.data.message){
      toast.error(err.response.data.message);
    }
  }
};

export const updateCityStatus = (formData) => async (dispatch) => {
  try {
    const res = await axios.post('/city/status', formData);
    if (res.data.code === 1) {
      dispatch({ type: UPDATE_COUNTRY, payload: res.data.data });
      setTimeout(() => {
        toast.success("City updated successfully!");
      }, 1000);
    } 
    if (res.data.code === 2) {
      setTimeout(() => {
        toast.warn(res.data.message);
      }, 1000);
    }
  } catch (err) {
    if(err.response.data.message){
      toast.error(err.response.data.message);
    }
  }
};

// Get getCities
export const getCities = (params) => async (dispatch) => {
  try {
    const res = await axios.get(`${process.env.REACT_APP_ADMIN_URL}/city/all`, {params});
    if (res.data.code === 1) {
      dispatch({ type: GET_CITIES, 
        payload: {
        data: res.data.data || [],
        pagination: res.data.pagination || {},
        totalCount: res.data.totalCount || 0,
      } });
    }
  } catch (err) {
    dispatch(setAlert(err.message, 'danger'));
  }
};

// Get Single City
export const getCity = (id) => async (dispatch) => {
  try {
    const res = await axios.get(
      `${process.env.REACT_APP_ADMIN_URL}/city/${id}`,
    );
    if (res.data.code === 1) {
      dispatch({ type: GET_CITY, payload: res.data.data, totalCount: res.data.totalCount });
      dispatch(setAlert(res.data.message, 'success'));
    } else {
      dispatch(setAlert(res.data.message, 'warning'));
    }
  } catch (err) {
    dispatch(setAlert(err.message, 'danger'));
  }
};

export const getCityByState = (id) => async (dispatch) => {
  try {
    const res = await axios.post(
      `${process.env.REACT_APP_ADMIN_URL}/city/state`,
      { stId: id },
    );
    if (res.data.code === 1) {
      dispatch({ type: GET_CITIES, payload: res.data.data });
      dispatch(setAlert(res.data.message, 'success'));
    } else {
      dispatch(setAlert(res.data.message, 'warning'));
    }
  } catch (err) {
    dispatch(setAlert(err.message, 'danger'));
  }
};

// Clear Single City
export const clearSingleCity = () => async (dispatch) => {
  try {
    dispatch({ type: GET_CITY, payload: '' });
  } catch (err) {
    dispatch(setAlert(err.message, 'danger'));
  }
};

// Update City
export const updateCity = (formData) => async (dispatch) => {
  try {
    const res = await axios.post(`${process.env.REACT_APP_ADMIN_URL}/city/update`, formData);
    if (res.data.code === 1) {
      dispatch({ type: UPDATE_CITY, payload: res.data.data });
      setTimeout(() => {
        toast.success("City updated successfully!");
      }, 1000);
    } 
    if (res.data.code === 2) {
      setTimeout(() => {
        toast.warn(res.data.message);
      }, 1000);
    }
  } catch (err) {
    if(err.response.data.message){
      toast.error(err.response.data.message);
    }
  }
};

// Delete City
export const deleteCity = (id) => async (dispatch) => {
  try {
    if (!id) {
      dispatch(setAlert('Please select any record', 'warning'));
      return false;
    }
    const res = await axios.post(`${process.env.REACT_APP_ADMIN_URL}/city/delete/${id}`);
    if (res.data.code === 1) {
      dispatch({ type: DELETE_CITY, payload: { id } });
      setTimeout(() => {
        toast.success("City deleted successfully!");
      }, 1000);
    }
    if (res.data.code === 2) {
      setTimeout(() => {
        toast.warn(res.data.message);
      }, 1000);
    }
  } catch (err) {
    if(err.response.data.message){
      toast.error(err.response.data.message);
    }
  }
};
